import { render, staticRenderFns } from "./GroupedList.vue?vue&type=template&id=df27344c&lang=pug&"
var script = {}
import style0 from "./GroupedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports